// skills/admin/index.js
// Admin skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import { renderAdminUI, updateAdminUI, initAdminUI } from './adminUI.js';

/**
 * Admin panel configuration
 * Note: This is a dev-only skill for testing/debugging
 */
const adminConfig = {
    id: 'admin',
    name: 'Admin',
    icon: '⚙️',
    description: 'Developer tools and overrides',

    // Admin is dev-only and hidden from sidebar by default
    devOnly: true,
    hidden: false, // We want it visible in dev mode

    tabs: [
        { id: 'panel', name: 'Panel', default: true },
    ],

    // Custom CSS is loaded from admin.css
    css: '/styles/skills/admin.css',

    render(params = {}) {
        renderAdminUI();
    },

    update() {
        updateAdminUI();
    },

    init() {
        initAdminUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('admin', adminConfig);

export default adminConfig;
